package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.autoComplete
import org.jetbrains.compose.web.attributes.builders.InputAttrsScope
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.required
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input

// Placeholder uses the same color as the field's text (and outline)
val inheritPlaceholderColorStyle = CssStyle {
    cssRule("::placeholder") {
        Modifier
            .color(Color("inherit"))
            .opacity(1)
    }
}

@Composable
fun InputField(
    inputType: InputType.InputTypeWithStringValue,
    value: String,
    placeholder: String,
    isValid: Boolean,
    autoComplete: AutoComplete? = null,
    onBlur: () -> Unit = {},
    onValueChange: (String) -> Unit
) {
    var isFocused by remember { mutableStateOf(false) }
    var isTouched by remember { mutableStateOf(false) }

    // Only show the error once the user has left the field
    val showError = isTouched && !isFocused && !isValid

    val textStyleAttrs = AppTheme.typography.body1.toModifier()
        .color(AppTheme.colors.text)
        .toAttrs<InputAttrsScope<String>>()
    val placeholderAttrs = inheritPlaceholderColorStyle.toAttrs<InputAttrsScope<String>>()
    val borderColor = AppTheme.colors.text
    val errorColor = AppTheme.colors.error

    Input(
        type = inputType,
        attrs = {
            textStyleAttrs(this)
            placeholderAttrs(this)
            style {
                width(100.percent)
                padding(12.px)
                backgroundColor(Color.transparent)
                border(1.px, LineStyle.Solid, if (showError) errorColor else borderColor)
                borderRadius(6.px)
                boxSizing("border-box")
            }
            this.value(value)
            onInput { event ->
                onValueChange(event.value)
            }
            onFocus {
                isFocused = true
                isTouched = true
            }
            onBlur {
                isFocused = false
                onBlur()
            }
            placeholder(placeholder)
            required()
            autoComplete?.let { autoComplete(it) }
        }
    )
}
